import assign from 'lodash/assign'
import {
  SET_AXG_STATE,
  RESET_INPUT,
} from '../action-types'


const initialState = {
}

export default function AXGState(state=initialState, action) {
  switch (action.type) {
    case SET_AXG_STATE:
      state[action.options.key] = action.options.value
      return assign({}, state)
    case RESET_INPUT:
      return {
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/axg-state.js